import { z } from 'zod/v3';
import { WorkspaceRoleSchema } from '../generated/enums'

export const WorkspaceMemberUserDTOSchema = z.object({
  id: z.string(),
  name: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
})

export const WorkspaceMemberDTOSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  userId: z.string(),
  role: WorkspaceRoleSchema,
  user: WorkspaceMemberUserDTOSchema.optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
})

export const AddWorkspaceMemberDTOSchema = z.object({
  userId: z.string(),
  role: WorkspaceRoleSchema.default('COLLABORATOR'),
})

export const UpdateWorkspaceMemberRoleDTOSchema = z.object({
  memberId: z.string(),
  role: WorkspaceRoleSchema,
})

export type WorkspaceMemberDTO = z.infer<typeof WorkspaceMemberDTOSchema>
export type AddWorkspaceMemberDTO = z.infer<typeof AddWorkspaceMemberDTOSchema>
export type UpdateWorkspaceMemberRoleDTO = z.infer<typeof UpdateWorkspaceMemberRoleDTOSchema>
